import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import styled from 'styled-components'

import { PairSearchItem } from '@root/entities/pair/ui/pair-search-item'
import { trendingPairsAtom } from '@root/features/trending-pairs'
import { useTranslation } from '@root/shared/localization'
import { Separator as Separator_ } from '@root/shared/ui-kit'
import { FadeOverflowVirtuozo } from '@root/shared/ui-kit/utils/fade-overflow-virtuozo'

import type { Pair } from '@root/entities/pair'

type Props = {
  onPairSelected?: (pair: Pair.PairMinimal) => void
  onClose?: () => void
}

export const SearchModalRecommended: React.FC<Props> = ({
  onPairSelected,
  onClose,
}) => {
  const { t } = useTranslation()

  const [pairs] = useAtom(trendingPairsAtom)

  return (
    <Root
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
      }}
    >
      <Header>
        <Separator />
        <Title>{t('trending')}</Title>
        <Separator />
      </Header>
      <FadeOverflowVirtuozo
        data={pairs}
        itemContent={(_, pair) => (
          <ListItem>
            <PairSearchItem
              key={pair.address}
              pair={pair}
              onClick={onPairSelected}
              onLinkClick={onClose}
            />
          </ListItem>
        )}
      />
    </Root>
  )
}

const Root = styled(motion.div)`
  display: grid;
  grid-template-rows: auto 1fr;
  overflow-x: hidden;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  gap: 10px;
  padding-block: 6px;
  padding-inline: 15px;
`

const Title = styled.p`
  color: var(--text-9);

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`

const Separator = styled(Separator_)`
  background: var(--background-2);
`

const ListItem = styled.div`
  padding: 3px 12px;
`
